import {applyMiddleware, combineReducers, compose, createStore} from 'redux';
import { ofType, combineEpics, createEpicMiddleware } from "redux-observable";
import listen from 'redux-action-listeners';
import { map, flatMap } from "rxjs/operators";
import createSagaMiddleware from 'redux-saga';
import {mboxAndPinReducer,sendPinEpic,submitPinEpic} from '../actions/mbox-and-pin-epics';

const storage = () => {

    const epicMiddleware = createEpicMiddleware();
    const sagaMiddleware = createSagaMiddleware()

    let middlewares = [
        sagaMiddleware,
        epicMiddleware
    ];
    // if (SiteConfig.env !== 'production') {
    const {createLogger} = require('redux-logger');
    middlewares.push(createLogger());
    // }
    let reducers = {
        mboxAndPin: mboxAndPinReducer
    }

    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

    const store = createStore(
        combineReducers(reducers),
        composeEnhancers(applyMiddleware(...middlewares))
    )
    const sagas = [
    ];
    sagas.forEach(saga => sagaMiddleware.run(saga))

    epicMiddleware.run(combineEpics(
     sendPinEpic,submitPinEpic
    ))
    return store;
}

export default storage;
